<icon-button [icon]="currentIcon" (click)="toggleExpandingQuickMenu()" [class.shrink-icon]="isExpanded"></icon-button>
<div class="menu-content" [@heightExpandCollapse]="animationState">
    <ng-content></ng-content>
</div>